import { css } from 'styled-components'

export const flex = css`
    display: flex;
`
